<template>
  <div class="fccSirs">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actionsBanco"
            addFilter
            :items="lstBancos"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldBanco"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="banco.id === 0 ? adicionarFormaPagamento() : editarBanco()"
        >
          <div class="row innerPage">
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="banco.codigo" id="codigo"
                >Código Banco</fccInput
              >
            </div>
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="banco.banco" id="banco"
                >Nome Banco</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fcc-select
                class="mb-4"
                placeholder="Selecione um tipo de retorno"
                labelField="tipoAcesso"
                valueField="tipoAcesso"
                v-model="banco.tipoacesso"
                :options="listarTipoAcesso"
                required
              >
                Tipo Acesso
              </fcc-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="banco.urlapi" id="urlApi"
                >URL API</fccInput
              >
            </div>
          </div>

          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Cadastro de Bancos',
      titlePDF: 'Cadastro de Bancos',
      titleModal: '',
      fields: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'banco', label: 'Banco', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      banco: {},
      lstBancos: [],
      listarTipoAcesso: [
        {
          tipoAcesso: 'Download'
        },
        {
          tipoAcesso: 'Redireciona'
        },
        {
          tipoAcesso: 'Link'
        }
      ],
      actionsBanco: [
        {
          button: true,
          funcaoButton: 'editBanco',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteBanco',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    alteraGru(tipo = 1) {
      if (tipo == 1) {
        this.banco.grucobranca = false
      } else {
        this.banco.grusimples = false
      }
    },
    deleteBanco: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.banco).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao + 'PublicacaoBanco/ExcluirBanco/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarBancos()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    addField() {
      this.banco = {}
      this.banco.id = 0
      this.titleModal = 'Adicionar Banco'
      this.$root.$emit('bv::show::modal', 'addFieldBanco')
    },
    editarBanco() {
      this.banco.banco = this.banco.banco.toUpperCase()
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoBanco/AlterarBanco',
          this.banco,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarBancos()
          this.$root.$emit('bv::hide::modal', 'addFieldBanco')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionarFormaPagamento() {
      this.banco.banco = this.banco.banco.toUpperCase()
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoBanco/Inserir',
          this.banco,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarBancos()
          this.$root.$emit('bv::hide::modal', 'addFieldBanco')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editBanco(_, item) {
      this.banco = { ...item }
      this.titleModal = 'Editar Banco'
      this.$root.$emit('bv::show::modal', 'addFieldBanco')
    },
    listarBancos() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarBancosGenerico().then((resposta) => {
        this.lstBancos = resposta
        this.carregaTexto()
      })
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarBancos()
  }
}
</script>
